<template>
  <f7-page name="credits-transfer" ref="page">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('TransferCredits') }}</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-only href="/credits/transfer-history/">
          <f7-icon icon="f7-icons icon-live-date"></f7-icon>
        </f7-link>
        <label :for="`submit-${submitId}`" class="link icon-only">
          <i class="icon f7-icons">checkmark_alt</i>
        </label>
      </f7-nav-right>
    </f7-navbar>
    <f7-progressbar v-if="isLoading" infinite color="green" class="progressbar-top"></f7-progressbar>

    <f7-block-title>{{ $t('TransferCredits') }}</f7-block-title>
    <f7-block>
      <p>{{ $t('TransferCreditsDescription') }}</p>
      <p v-html="$t('YourBalance', {c: UserInfo.SMSTimes})"></p>
    </f7-block>

    <form action="" @submit.prevent="onSubmit">
      <input type="submit" :id="`submit-${submitId}`" hidden >

      <f7-list class="no-margin-top no-hairline-bottom">
        <li class="item-input custom-smart-select-wrapper">
          <a ref="AutocompleteTransferTo" class="item-link item-content" href="#" id="autocomplete-standalone-ajax">
            <input type="hidden" :value="SelectedUserCode"/>
            <span class="item-media">
              <f7-icon icon="f7-icons icon-customer-details text-color-lightgray"></f7-icon>
            </span>
            <div class="item-inner">
              <div class="item-title">{{ $t('TransferTo') }}</div>
              <div class="item-after">{{ SelectedUserName }}</div>
            </div>
          </a>
        </li>
        <f7-list-item :title="$t('CreditsToTransfer')">
          <template #media>
            <f7-icon icon="f7-icons icon-menu-credits text-color-lightgray"></f7-icon>

          </template>
          <template #after>
            <f7-stepper
                fill
                v-model:value="credits"
                :min="1"
                :max="UserInfo.SMSTimes"
                :step="5"
                :autorepeat="true"
                :wraps="true"
                :manual-input-mode="true"
                :decimal-point="0"></f7-stepper>
          </template>
        </f7-list-item>
      </f7-list>
    </form>
  </f7-page>
</template>

<script>
import {mapGetters} from "vuex";
import {f7} from "framework7-vue";
import {QTAPI} from "../../services/qt-api";

export default {
  name: "credits-transfer",

  props: {
    f7router: Object,
    f7route: Object,
  },

  data() {
    return {
      submitId: f7.utils.id(),
      isLoading: false,

      credits: 10,
      MinSearchLength: 2,
      SelectedUserCode: this.f7route.query?.userCode || null,
      SelectedUserName: this.f7route.query?.customerName ? `${ this.f7route.query.customerName } (${ this.f7route.query.customerEmail })` : null,
      autocompleteTransferTo: null,
    }
  },

  computed: {
    ...mapGetters(['UserInfo', 'MajorToken', 'MinorToken']),
  },

  mounted() {
    let self = this

    this.autocompleteTransferTo = f7.autocomplete.create({
      openIn: 'page', //open in page
      openerEl: self.$refs.AutocompleteTransferTo, //link that opens autocomplete
      valueProperty: 'Code', //object's "value" property name
      textProperty: 'customDisplayName', //object's "text" property name
      closeOnSelect: true,
      autoFocus: true,
      limit: 50,
      preloader: true, //enable preloader
      searchbarPlaceholder: self.$t('EnterMinCharacters', {q: self.MinSearchLength}),
      source: async function (query, render) {
        let autocomplete = this;

        if (query.length < self.MinSearchLength) {
          return;
        }
        // Show Preloader
        autocomplete.preloaderShow();

        let data = {
          MajorToken: self.MajorToken,
          MinorToken: self.MinorToken,
          page: 1,
          rows: 20,
          sort: 'Name',
          order: 'asc',
          q: query,
        }
        let response = await QTAPI.GetCustomers(data)
        autocomplete.preloaderHide();
        if(!response || !response.rows){
          render([]);
          return
        }

        for (var i = 0; i < response.rows.length; i++) {
          response.rows[i].customDisplayName = `${ response.rows[i].Name } (${ response.rows[i].Email })`
        }

        render(response.rows);
      },
      on: {
        change: function (value) {
          var itemText = [],
              inputValue = [];
          for (var i = 0; i < value.length; i++) {
            itemText.push(value[i].customDisplayName);
            inputValue.push(value[i].UserCode);
          }
          self.SelectedUserCode = inputValue.join(', ')
          self.SelectedUserName = itemText.join(', ')
        },
      },
    });

  },
  beforeUnmount() {
    const self = this;
    // Destroy popup when page removed
    if (self.autocompleteTransferTo) self.autocompleteTransferTo.destroy();
  },

  methods: {
    async onSubmit(){
      if(!this.SelectedUserCode){
        f7.dialog.alert( this.$t('SelectCustomerAccount'), this.$t('Error') )
        return
      }
      let data = {
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken,

        ToUserCode: this.SelectedUserCode,
        Credits: this.credits
      }

      this.isLoading = true;
      let response = await QTAPI.CreditsTransfer(data)
      this.isLoading = false;
      if (!response){
        return
      }
      this.$store.dispatch('GetCreditBalance')
      f7.dialog.alert(this.$t('CreditTransferred', { name: this.SelectedUserName, credits: response.To.Credits }), this.$t('Success'))
      this.f7router.back()
    }
  }
}
</script>

<style scoped>

</style>